<script>
import Drawer from './components/Drawer.svelte';
import Alerts from './components/Alerts.svelte';
export let message = '';
</script>

<Drawer />
<Alerts />

<div class="container">
    <h1>500</h1>
    <h2>An error occurred!</h2>
    <p>{message}</p>
</div>